import { klienci } from "./klienci";
import {
  Sekcja,
  Kontener,
  Strzalka,
  Karta,
  Autor,
  Gwiazda,
  Opinia,
  DotsContainer,
  Dot,
  Tytul,
  Ikona,
  Wstep,
  Summary,
  Score,
  ReviewsLink,
  Viewport, Track, Controls, ReadMore,
} from "./styled";
import { useState, useEffect, useRef } from "react";
import gwiazdka from "../../../images/gwiazdka.png";
import { theme } from "../../../theme";
import { reviewsWebUrl, googleNavigationProps } from "../../../googleMapsLinks";

const Opinie = ({ compact = false }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hovered, setHovered] = useState(false);
  const [lastInteraction, setLastInteraction] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const touchStart = useRef(null);
  const [opinionsPerPage, setOpinionsPerPage] = useState(3);

  useEffect(() => {
    const updateOpinionsPerPage = () => {
      if (window.innerWidth < theme.breakpoint.tabletMax) {
        setOpinionsPerPage(1);
      } else {
        setOpinionsPerPage(3);
      }
    };

    window.addEventListener("resize", updateOpinionsPerPage);
    updateOpinionsPerPage();
    return () => window.removeEventListener("resize", updateOpinionsPerPage);
  }, []);

  useEffect(() => {
    if (hovered || expanded !== null || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const timer = window.setInterval(() => {
      if (!document.hidden && Date.now() - lastInteraction >= 6500) setCurrentIndex(index => (index + 1) % (klienci.length - opinionsPerPage + 1));
    }, 6500);
    return () => window.clearInterval(timer);
  }, [hovered, lastInteraction, expanded, opinionsPerPage]);
  useEffect(() => { setCurrentIndex(index => Math.min(index, klienci.length - opinionsPerPage)); }, [opinionsPerPage]);
  const change = delta => { setLastInteraction(Date.now()); setExpanded(null); setCurrentIndex(index => (index + delta + klienci.length - opinionsPerPage + 1) % (klienci.length - opinionsPerPage + 1)); };
  return (
    <Sekcja id="opinie" $compact={compact}>
      <Summary>
        <div><p>Opinie klientów</p><h2>{compact ? "Klienci o współpracy z nami" : "Co mówią o nas inni?"}</h2></div>
        <Score><strong>5.0</strong><span>ocena w Google</span></Score>
        <ReviewsLink
          data-reviews-link
          {...googleNavigationProps(reviewsWebUrl)}
        >
          Zobacz wszystkie opinie w Google →
        </ReviewsLink>
      </Summary>
      <p className="review-summary">Klienci najczęściej doceniają spokojne wyjaśnienie procesu, sprawne dopilnowanie formalności i kontakt na każdym etapie.</p>
      <Kontener role="region" aria-label="Opinie klientów" aria-roledescription="karuzela"
        onMouseEnter={() => { if (window.matchMedia?.("(hover: hover)").matches) setHovered(true); }} onMouseLeave={() => setHovered(false)}
        onFocusCapture={() => setLastInteraction(Date.now())}
        onTouchStart={event => { touchStart.current = { x:event.touches[0].clientX, y:event.touches[0].clientY }; setLastInteraction(Date.now()); }}
        onTouchEnd={event => { const start=touchStart.current; if (start) { const dx=event.changedTouches[0].clientX-start.x; const dy=event.changedTouches[0].clientY-start.y; if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) change(dx<0?1:-1); } touchStart.current=null; }}>
        <Viewport><Track $index={currentIndex} $perPage={opinionsPerPage}>
          {klienci.map((opinia, index) => <Karta key={opinia.autor} $perPage={opinionsPerPage} aria-hidden={index < currentIndex || index >= currentIndex + opinionsPerPage}>
            <Tytul><Wstep><Ikona aria-hidden="true">G</Ikona><Autor>{opinia.autor}</Autor></Wstep><div aria-label="5 na 5 gwiazdek">{Array.from({length:5}, (_, i) => <Gwiazda key={i} src={gwiazdka} alt="" />)}</div></Tytul>
            <Opinia $expanded={expanded === index}>{opinia.tekst}</Opinia>
            {opinia.tekst.length > 230 && <ReadMore type="button" tabIndex={index >= currentIndex && index < currentIndex + opinionsPerPage ? 0 : -1} aria-expanded={expanded === index} onClick={() => setExpanded(expanded === index ? null : index)}>{expanded === index ? "Zwiń opinię" : "Czytaj więcej"}</ReadMore>}
          </Karta>)}
        </Track></Viewport>
        <Controls><Strzalka type="button" onClick={() => change(-1)} aria-label="Poprzednia opinia">←</Strzalka><Strzalka type="button" onClick={() => change(1)} aria-label="Następna opinia">→</Strzalka></Controls>
      </Kontener>
      <DotsContainer>
        {klienci.slice(0, klienci.length - opinionsPerPage + 1).map((_, index) => (
          <Dot
            type="button"
            key={index}
            $active={index === currentIndex}
            aria-label={`Pokaż opinię ${index + 1}`}
            aria-current={index === currentIndex ? "true" : undefined}
            onClick={() => { setExpanded(null); setLastInteraction(Date.now()); setCurrentIndex(index); }}
          />
        ))}
      </DotsContainer>
    </Sekcja>
  );
};

export default Opinie;

